import React, {useEffect} from 'react';
import {Link} from 'react-router-dom'
import './News.css';
import {images} from '../images/images';


const NewsTemplate = (props) => {

	return (
		<figure className='newsThumbnail'>
			<div className='darkOverlay' />
			<h1>{props.title}:<br/>{props.name}</h1>
			<img className='thumbnailImage' src={props.img} alt={props.name}/>
		</figure>
	)
}

export const News = () => {

	

	return(
		<main className='newsContainer'>	
			<h1 className='sectionTitle'>News</h1>
			<Link to='/profile/soul_clap'>
				<NewsTemplate title='Artist' name='Soul Clap' img={images.soulClap.cover}/>
			</Link>
			<hr className='space contentSeperator' />
		</main>
		)
}